import React from 'react';
import clsx from 'clsx';
import './index.scss';

export const LayoutBlock = ({ className, children, ...other }) => {
  return <div className={clsx('layoutBlock', className)}>{children}</div>;
};
